import { render, staticRenderFns } from "./storage-time.vue?vue&type=template&id=bea424a8&"
import script from "./storage-time.vue?vue&type=script&lang=js&"
export * from "./storage-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports